<template>
  <v-container grid-list-md>
    <!-- <p>{{ AccountNumber }}</p> -->
    <v-card flat>
      <v-form ref="ExchangeForme" v-model="valid">
        <v-row dense no-gutters class="justify-center">
          <v-col cols="12" md="6" lg="6" xl="6">
            <v-radio-group
              readonly
              :rules="[v => !!v || 'Exchang Type is required']"
              v-model="Exchange.sellOrBuy"
              :column="false"
            >
              <v-radio label="Sell" value="Sell"></v-radio>
              <v-radio label="Buy" value="Buy"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="8">
            <v-select
              outlined
              dense
              v-model.trim="Exchange.sellorBuyType"
              :items="GetCashTypes"
              :rules="[v => !!v || 'Cash Type is required']"
              label="Cash Type"
              required
            ></v-select>
          </v-col>
          <!-- currency Amount and its formating Number -->
          <v-col cols="8">
            <BaseNumInput
              outlined
              dense
              :prefix="Exchange.sellorBuyType | MoneySigns"
              v-model.trim="Exchange.sellorBuyAmount"
              :rules="[v => !!v || 'Amount is required']"
              name="ExchangeAmount"
              label="Amount"
            ></BaseNumInput>
            <!-- </v-col>
          <v-col cols="8">
            <p
              v-if="Exchange.sellorBuyAmount"
              class="font-weight-black text-center black--text"
            >
              {{ Exchange.sellorBuyType | MoneySigns }}
              {{ Exchange.sellorBuyAmount.toLocaleString() }}
            </p>
          </v-col>
          <v-col cols="8"> -->
            <v-select
              outlined
              dense
              v-model.trim="ExchangType"
              :items="CurrencyTyps"
              :rules="[v => !!v || 'Exchange Type is required']"
              :disabled="
                ExchangType == LocalCurrencyGetter[0].Cashcode ? true : false
              "
              label="Exchange Type"
              required
            ></v-select>
            <!-- </v-col>
          <v-col cols="8"> -->
            <v-text-field
              outlined
              dense
              v-model.number.trim="Exchange.Rate"
              :rules="[v => !!v || 'Rate is required']"
              name="ExchangeAmountRate"
              label="Rate"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="8">
            <p
              class="font-weight-black text-center black--text"
              v-if="localCurrence && localCurrence > 0"
            >
              <!-- {{ localCurrence.toLocaleString() }} -->
              {{ (Math.round(localCurrence * 100) / 100).toLocaleString() }}

              {{ ExchangType | MoneySigns }}
            </p>
          </v-col>
        </v-row>
      </v-form>

      <v-card-actions>
        <v-btn
          block
          :loading="clicked"
          :color="colorChange"
          @click="OnBankExchange"
          >{{ Exchange.sellOrBuy }} - Money</v-btn
        >
      </v-card-actions>
      <p class="text-center mb-3 red--text d-block">{{ ErrorMsg }}</p>
      <!-- <p class="text-center mb-3 red--text d-block">{{ AccountNumber }}</p> -->
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    AccountNumber: [Number],
    showBalance: { type: Function },
    closed: { type: Boolean },
    isLoading: { type: Function },
  },
  data() {
    return {
      //   sellOrBuy: "",
      valid: true,
      ErrorMsg: "",
      clicked: false,
      ExchangType: "",
      Exchange: {
        sellorBuyAmount: null,
        Rate: "",
        sellorBuyType: "",
        sellOrBuy: "",
        Amount: "",
      },
    };
  },
  computed: {
    ...mapGetters(["GetCashTypes", "LocalCurrencyGetter"]),
    CurrencyTyps() {
      if (this.GetCashTypes.length > 0)
        return this.GetCashTypes.filter(value => {
          // return value.value != this.LocalCurrencyGetter[0].Cashcode;
          return value.value != this.Exchange.sellorBuyType;
        });
      else return [];
    },
    colorChange() {
      if (this.Exchange.sellOrBuy === "Sell") return "green white--text";
      else if (this.Exchange.sellOrBuy == "Buy") return "yellow black--text";
      else return "grey white--text";
    },
    watchSellOrBuyType() {
      return this.Exchange.sellorBuyType;
    },
    // localCurrence() {
    //   if (
    //     this.Exchange.Rate &&
    //     this.Exchange.sellorBuyAmount &&
    //     !isNaN(this.Exchange.Rate) &&
    //     !isNaN(this.Exchange.sellorBuyAmount)
    //   )
    //     if (this.Exchange.sellorBuyType == this.LocalCurrencyGetter[0].Cashcode)
    //       return (
    //         Number(this.Exchange.sellorBuyAmount) / Number(this.Exchange.Rate)
    //       );
    //     else return this.Exchange.Rate * this.Exchange.sellorBuyAmount;
    //   else return 0;
    // },
    localCurrence() {
      if (
        this.Exchange.Rate &&
        this.Exchange.sellorBuyAmount &&
        !isNaN(this.Exchange.Rate) &&
        !isNaN(this.Exchange.sellorBuyAmount)
      )
        if (
          this.Exchange.sellorBuyType == this.LocalCurrencyGetter[0].Cashcode
        ) {
          if (this.LocalCurrencyGetter[0].Cashcode == "USD")
            return (
              Number(this.Exchange.sellorBuyAmount) * Number(this.Exchange.Rate)
            );
          return (
            Number(this.Exchange.sellorBuyAmount) / Number(this.Exchange.Rate)
          );
        } else {
          if (this.LocalCurrencyGetter[0].Cashcode == "USD")
            return (
              Number(this.Exchange.sellorBuyAmount) / Number(this.Exchange.Rate)
            );
          return this.Exchange.Rate * this.Exchange.sellorBuyAmount;
        }
      else return 0;
    },
  },
  watch: {
    watchSellOrBuyType(v) {
      if (v == this.LocalCurrencyGetter[0].Cashcode) {
        this.Exchange.sellOrBuy = "Sell";
        // this.ExchangType = "USD";
        this.ExchangType = this.CurrencyTyps.length
          ? this.CurrencyTyps[0].value
          : "";
      } else if (this.closed) {
        this.Exchange.sellOrBuy = "Buy";
        this.ExchangType = this.LocalCurrencyGetter[0].Cashcode;
      }
    },
    localCurrence(val) {
      this.Exchange.Amount = Math.round(val * 100) / 100;
    },
    closed(val) {
      if (!val) {
        this.$refs.ExchangeForme.reset();
        this.isLoading(false);
      }
    },
  },
  methods: {
    OnBankExchange() {
      this.ErrorMsg = "";

      if (this.$refs.ExchangeForme.validate()) {
        this.isLoading(true);
        this.clicked = true;
        this.Exchange.date = this.Current().date;
        this.Exchange.time = this.Current().time;
        this.Exchange.homeType = this.LocalCurrencyGetter[0].Cashcode;
        let data = { ...this.Exchange, ClientAccount: this.AccountNumber };
        if (this.Exchange.sellOrBuy == "Sell") {
          data.Amount = this.Exchange.sellorBuyAmount;
          data.sellorBuyAmount = this.Exchange.Amount;
          data.sellorBuyType = this.ExchangType;
        }
        // console.log(data);
        this.$store
          .dispatch("INSERT_ONLY", {
            url: `/qarash/${this.Exchange.sellOrBuy}`,
            data,
          })
          .then(result => {
            this.isLoading(false, "Finished");
            this.clicked = false;
            this.showBalance(result.data);
            this.$refs.ExchangeForme.reset();
            // console.log(result);
          })
          .catch(error => {
            // console.log(error);
            this.clicked = false;
            this.isLoading(false);
            if (error.response.status === 400)
              this.ErrorMsg = error.response.data;
            else if (error.response.status === 451)
              this.ErrorMsg = error.response.data;
          });
      }
    },
  },
  mounted() {
    this.isLoading(false);
  },
};
</script>
